import { render, staticRenderFns } from "./OrderCharacteristicsView.vue?vue&type=template&id=77855544&scoped=true&"
import script from "./OrderCharacteristicsView.vue?vue&type=script&lang=js&"
export * from "./OrderCharacteristicsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77855544",
  null
  
)

export default component.exports